module.exports = __webpack_public_path__ + "img/p-15-1.175a69da.png";